module.exports = __webpack_public_path__ + "img/pavel.t__600x600.04933297.jpg";